/* eslint-disable react/jsx-curly-newline */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable comma-dangle */
/* eslint-disable arrow-parens */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';

import { Container, Context, ViewForm } from './styles';

import api from '~/services/api';

import Iniciante from '~/assets/images/Iniciante.png';
import Intermediario from '~/assets/images/Intermediario.png';
import Basico from '~/assets/images/Basico.png';
import Avancado from '~/assets/images/Avancado.png';
import Master from '~/assets/images/Master.png';
// import Certificado from '~/assets/images/certificado.png';

const image = [Iniciante, Basico, Intermediario, Avancado, Master];
const levels = ['INICIANTE', 'BÁSICO', 'INTERMEDIÁRIO', 'AVANÇADO', 'MASTER'];

export default function Tutoring() {
  const user = useSelector((state) => state.user.profile);
  const { id } = useParams();
  const [job, setJob] = useState('');
  const [file, setFile] = useState('');
  const [date, setDate] = useState('');
  const [tags, setTags] = useState('');
  // const [subjects, setSubjects] = useState([]);
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    async function getData() {
      const { data } = await api.get(`jobs/${id}`);
      setJob(data);
    }
    async function getDataFile() {
      const { data } = await api.get(`jobs/${id}`);
      setFile(data.file);
    }

    async function getDataDate() {
      const { data } = await api.get(`jobs/${id}`);
      setDate(data.updated_at);
    }

    async function getDataTags() {
      const { data } = await api.get(`jobs/${id}`);
      setTags(data.area_job);
    }

    // async function getDataSubjects() {
    //   const { data } = await api.get(`jobs/${id}`);
    //   setSubjects(data.modules);
    // }

    async function getDataJobs() {
      const { data } = await api.get('/alljobs');
      setJobs(data);
    }

    getData();
    getDataFile();
    getDataDate();
    getDataTags();
    // getDataSubjects();
    getDataJobs();
  }, [id]);

  const year = date.slice(0, 4);
  const month = date.slice(6, 7);
  const day = date.slice(8, 10);

  const tagsFormated = tags.split(',');

  async function handleSubmit(e) {
    e.preventDefault();

    if (job.apollo_level <= user.apollo_level) {
      try {
        await api.post(`/jobs/${job.id}/applies`);
        const { data } = await api.get('/alljobs');
        setJobs(data);
        return toast.success('Vaga aplicada com sucesso.');
      } catch (error) {
        return toast.warning(
          'Você já se candidatou para essa vaga, verifique o seu Dashboard.'
        );
      }
    } else {
      return toast.warning(
        `💻 Para se candidatar a essa vaga seu Nível Apollo precisa ser ${
          levels[job.apollo_level - 1]
        } ou acima.`,
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  }

  return (
    <>
      <h1 style={{ color: '#36ded6', marginLeft: 30, paddingTop: 30 }}>
        Detalhes da Vaga #{job.id}
      </h1>
      <Container>
        <Context>
          <h1>{job.title}</h1>
          <div className="header">
            <div className="image">
              <img src={`${file.url}`} alt="image_file" />
              <div>
                <p>{job.company}</p>
                <p>{job.local}</p>
              </div>
            </div>
            <div className="date">
              <p>Vaga aberta em: </p>
              <p> {format(new Date(year, month - 1, day), 'dd/MM/yyyy')}</p>
            </div>
            <div>
              <p>Áreas da vaga:</p>

              <div className="tags">
                {tagsFormated.map((tag) => (
                  <div className="tag" key={tag}>
                    <div className="circle" />
                    <p>{tag}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{ height: 300, padding: 20 }}>
            <p>{job.description}</p>
          </div>
          <p className="type">Tipo de vaga? {job.type_job}</p>
          <p className="description">
            Vaga aceita trabalho remoto? {job.remote_job}
          </p>
          <p className="description">
            {' '}
            Salário:{' '}
            {job.salary
              ? `R$ ${parseFloat(job.salary).toFixed(2)}`
              : 'Nāo Informado'}
          </p>
          {jobs.includes(job.id) === true ? (
            <button
              type="submit"
              className="disabled"
              onClick={() =>
                toast.warning(
                  'Você já se candidatou para essa vaga, verifique o seu Dashboard.'
                )
              }
            >
              VAGA JÁ APLICADA
            </button>
          ) : (
            <button type="submit" onClick={(e) => handleSubmit(e)}>
              CANDIDATAR A VAGA
            </button>
          )}
        </Context>
        <ViewForm>
          <p className="disciple">NÍVEL APOLLO DESEJADO</p>
          <div className="apollo">
            <img src={`${image[job.apollo_level - 1]}`} alt="apollo_level" />
            <p>{levels[job.apollo_level - 1]}</p>
          </div>
          {/* <p className="disciple">CERTIFICADO DE NÉGÓCIO DESEJADO</p>
          <div className="businesss">
            {subjects.map((subject) =>
              subject.subject.type === 'business' ? (
                <div className="certificados" key={subject}>
                  <img src={`${Certificado}`} alt="business" />
                  <Link
                    to={`/playground/${subject.id}`}
                    target="_blank"
                    style={{ color: '#fff' }}
                  >
                    <p style={{ fontSize: 14, marginLeft: 5, width: 300 }}>
                      {subject.title}
                    </p>
                  </Link>
                </div>
              ) : null
            )}
          </div> */}
          {/* <p className="disciple">MÓDULOS DE TECNOLOGIA DESEJADO</p>
          <div className="business">
            {subjects.map((subject) =>
              subject.subject.type === 'development' ? (
                <div className="certificados" key={subject}>
                  <img src={`${Certificado}`} alt="business" />
                  <Link
                    to={`/playground/${subject.id}`}
                    target="_blank"
                    style={{ color: '#fff' }}
                  >
                    <p style={{ fontSize: 14, marginLeft: 5, width: 300 }}>
                      {subject.title}
                    </p>
                  </Link>
                </div>
              ) : null
            )}
          </div> */}
          <div />
          {/* <p className="disciple">SEU NÍVEL APOLLO ATUAL</p>
          <div className="apollo">
            <img src={`${image[user.apollo_level - 1]}`} alt="apollo_level" />
            <p>{levels[user.apollo_level - 1]}</p>
          </div> */}
          <div />
          <p className="disciple">Como aumentar o meu Nível Apollo?</p>
          <div className="apollo">
            <p className="description">Realizando os desafios de Tecnologia</p>
            <p className="description">Realizando os desafios de Negócios</p>
            <p className="description">
              Participando de projetos da Apollo Jr.
            </p>
          </div>
          <div />
        </ViewForm>
      </Container>
    </>
  );
}
